export default __webpack_public_path__ + "static/misc2-34b05dcc469f0a70c9a9c532a3dc14d9.jpg";